var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./api";
var USE_RETRIEVE_LEAGUE = "useRetrieveLeague";
var USE_RETRIEVE_LEAGUES_BY_PLAYER_ID = "useRetrieveLeaguesByPlayerId";
var USE_RETRIEVE_LEAGUE_TEAMS = "useRetrieveLeagueTeams";
var USE_RETRIEVE_ALL_LEAGUE_TEAMS = "useRetrieveAllLeagueTeams";
export var USE_RETRIEVE_ADDABLE_TEAMS = "useRetrieveAddableTeams";
var STALE_TIME = 1000 * 60 * 5;
var CACHE_TIME = 1000 * 60 * 30;
export var useRetrieveLeague = function (_a) {
    var id = _a.id, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_RETRIEVE_LEAGUE, id],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/leagues/".concat(id, "/"))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); },
        enabled: !!id && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useRetrieveLeaguesByPlayerId = function (_a) {
    var playerId = _a.playerId, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_RETRIEVE_LEAGUES_BY_PLAYER_ID, { playerId: playerId }],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/players/".concat(playerId, "/leagues/"))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); },
        enabled: !!playerId && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useRetrieveLeagueTeams = function (_a) {
    var leagueId = _a.leagueId, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_RETRIEVE_LEAGUE_TEAMS, leagueId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/leagues/".concat(leagueId, "/teams/"))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); },
        enabled: !!leagueId && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useRetrieveAllLeagueTeams = function (_a) {
    var leagueId = _a.leagueId, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_RETRIEVE_ALL_LEAGUE_TEAMS, leagueId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/leagues/".concat(leagueId, "/teams/"))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); },
        enabled: !!leagueId && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useRetrieveAddableTeams = function (_a) {
    var leagueId = _a.leagueId, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_RETRIEVE_ADDABLE_TEAMS, leagueId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/leagues/".concat(leagueId, "/teams/addable/"))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); },
        enabled: !!leagueId && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export var useCreateLeague = function (_a) {
    var onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.post("/leagues/", data)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([USE_RETRIEVE_LEAGUES_BY_PLAYER_ID]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useUpdateLeague = function (_a) {
    var id = _a.id, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.put("/leagues/".concat(id, "/"), data)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([USE_RETRIEVE_LEAGUE, id]);
            queryClient.invalidateQueries([USE_RETRIEVE_LEAGUES_BY_PLAYER_ID]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useDeleteLeague = function (_a) {
    var id = _a.id, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.delete("/leagues/".concat(id, "/"))];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.removeQueries([USE_RETRIEVE_LEAGUE, id]);
            queryClient.invalidateQueries([USE_RETRIEVE_LEAGUES_BY_PLAYER_ID]);
            onSuccess(data, undefined);
        },
        onError: onError,
    });
};
export var useCreateTeamAndAddToLeague = function (_a) {
    var leagueId = _a.leagueId, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (teamData) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, api.post("/leagues/".concat(leagueId, "/teams/create/"), teamData)];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([USE_RETRIEVE_LEAGUE_TEAMS, leagueId]);
            queryClient.invalidateQueries([USE_RETRIEVE_LEAGUE, leagueId]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useAddExistingTeamToLeague = function (_a) {
    var leagueId = _a.leagueId, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
            var teamIds = _b.teamIds;
            return __generator(this, function (_c) {
                return [2 /*return*/, api.post("/leagues/".concat(leagueId, "/teams/add-existing/"), { teamIds: teamIds })];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([USE_RETRIEVE_LEAGUE_TEAMS, leagueId]);
            queryClient.invalidateQueries([USE_RETRIEVE_LEAGUE, leagueId]);
            queryClient.invalidateQueries([USE_RETRIEVE_ADDABLE_TEAMS, leagueId]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useUpdateTeamMembershipStatus = function (_a) {
    var leagueId = _a.leagueId, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
            var teamId = _b.teamId, status = _b.status;
            return __generator(this, function (_c) {
                return [2 /*return*/, api.put("/leagues/".concat(leagueId, "/teams/update-status/"), { team_id: teamId, status: status })];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function (data) {
            queryClient.invalidateQueries([USE_RETRIEVE_LEAGUE_TEAMS, leagueId]);
            queryClient.invalidateQueries([USE_RETRIEVE_ALL_LEAGUE_TEAMS, leagueId]);
            queryClient.invalidateQueries([USE_RETRIEVE_LEAGUE, leagueId]);
            onSuccess(data);
        },
        onError: onError,
    });
};
export var useRemoveTeamFromLeague = function (_a) {
    var leagueId = _a.leagueId, onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
            var teamId = _b.teamId;
            return __generator(this, function (_c) {
                return [2 /*return*/, api.delete("/leagues/".concat(leagueId, "/teams/remove/"), {
                        data: { team_id: teamId },
                    })];
            });
        }); },
        onMutate: onMutate,
        onSuccess: function () {
            queryClient.invalidateQueries([USE_RETRIEVE_LEAGUE_TEAMS, leagueId]);
            queryClient.invalidateQueries([USE_RETRIEVE_ALL_LEAGUE_TEAMS, leagueId]);
            queryClient.invalidateQueries([USE_RETRIEVE_LEAGUE, leagueId]);
            queryClient.invalidateQueries([USE_RETRIEVE_ADDABLE_TEAMS, leagueId]);
            onSuccess();
        },
        onError: onError,
    });
};
